import LazyLoad from 'vanilla-lazyload/dist/lazyload.min';

const myLazyLoad = new LazyLoad({
  elements_selector: '.lazyload'
});



// WEBPACK FOOTER //
// ../assets/js/lazyload.js